import { render } from "./ProjectMenu.vue?vue&type=template&id=7ea005a5&scoped=true"
import script from "./ProjectMenu.vue?vue&type=script&lang=js"
export * from "./ProjectMenu.vue?vue&type=script&lang=js"

import "./ProjectMenu.vue?vue&type=style&index=0&id=7ea005a5&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea005a5"]])

export default __exports__